// extracted by mini-css-extract-plugin
export default {"button":"PopularButton_button__ET9Jh","icon":"PopularButton_icon__ztQq0","text":"PopularButton_text__jo3P4"};